<template>
  <div class="course-progress-bar">
    <div class="course-progress-bar__progress-container">

      <div
        class="course-progress-bar__progress"
        :style="{ width: animatedPercent + '%'}"
      ></div>

      <div class="course-progress-bar__steps-container">
        <div
          v-for="level in levels"
          :key="level.legend"
          class="course-progress-bar__step-item"
          :class="{'course-progress-bar__step-item--active': percent && percent >= level.minPercent}"
        >
          <span class="course-progress-bar__step-item-legend">
            {{ level.legend }}
          </span>
        </div>
      </div>
    </div>

    <span class="course-progress-bar__percent">
      {{ percent }}% concluído - {{ currentLevel.legend }}
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      percent: { type: Number, default: 0 }
    },

    data: () => ({
      animatedPercent: 0,
      levelsMap: [
        { legend: 'iniciante', minPercent: 0 },
        { legend: 'avançado', minPercent: 33 },
        { legend: 'expert', minPercent: 50 },
        { legend: '#PRO', minPercent: 80 },
      ]
    }),

    computed: {
      levels () {
        return this.levelsMap.slice()
          .sort((a, b) => a.minPercent - b.minPercent)
      },

      currentLevel () {
        return this.levels
          .reduce((carry, level) => {
            return (this.percent >= level.minPercent)
              ? level
              : carry
          }, {})
      },

      nextLevel () {
        return (level) => {
          const index = this.levels.findIndex(i => i.legend == level.legend)

          if (typeof this.levels[index+1] === 'undefined') {
            return null
          }

          return this.levels[index+1]
        }
      },

      stepItemProgressPercent () {
        return (level) => {
          if (this.percent > level.minPercent) {
            const nextLevel = this.nextLevel(level)

            if (!nextLevel) {
              return this.percent
            }

            return this.percent >= nextLevel.minPercent
              ? 100
              : (this.percent - level.minPercent) * 100 / (nextLevel.minPercent - level.minPercent)
          }

          return 0
        }
      },
    },

    mounted() {
      setTimeout(() => {
        this.animatedPercent = this.percent
      }, 100)
    },
    
    watch: {
      percent(newVal) {
        this.animatedPercent = newVal
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .course-progress-bar {
    position: relative;

    &__progress-container {
      display: flex;
      justify-content: space-between;
      height: 15px;
      border-radius: 15px;
      overflow: hidden;
      background-color: #D9D9D9;
    }

    &__progress {
      position: relative;
      background: linear-gradient(158deg, #FCB045 4.86%, #FD1D1D 52.82%, #7700C7 100.77%);
      height: 15px;
      border-radius: 15px;
      transition: width 0.3s ease;
    }

    &__steps-container {
      position: absolute;
      top: -3px;
      left: 0;
      right: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__step-item {
      $p: &;

      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      background-color: rgba(#000, .30);
      overflow: hidden;

      &-legend {
        font-size: 12px;
        color: rgba($white300, .35
        );
        z-index: 2;
        font-weight: 500;
      }

      &-progress {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        z-index: 1;
      }

      &--active {
        #{$p}-legend { color: $white300 }
        #{$p}-progress { color: $white300 }
      }

      &:first-child { 
        border-top-left-radius: 15px; 
        border-bottom-left-radius: 15px; 
      }
      &:last-child { 
        border-top-right-radius: 15px; 
        border-bottom-right-radius: 15px; 
      }
    }

    &__percent {
      font-size: 0.77rem;
      // color: $highlightPrimaryColor;
      margin-top: 5px;
      display: block;
      text-align: center;
    }
  }
</style>
